/**
 * Transcribed from Mason, Welch & Neratko (2018), Table 3 and Results/Figure 1.
 * All numbers are historical particles/L, including NR-tagged 6.5–100 µm
 * particles and the >100 µm fraction. Smaller particles were not all confirmed
 * spectroscopically. Lot means, bottle maxima and reported brand means are
 * separate fields; never assign Qian's unnamed 2024 cohort to these brands.
 */
export const BOTTLED_WATER_EVIDENCE_REVIEWED = '2026-10-06'
export const MASON_2018_URL = 'https://www.frontiersin.org/journals/chemistry/articles/10.3389/fchem.2018.00407/full'
export const QIAN_2024_URL = 'https://www.pnas.org/doi/10.1073/pnas.2300582121'

export interface BottledWaterEvidence {
  brand: string
  lotMeans: number[]
  bottleMaximum?: number
  reportedBrandMean?: number
  note?: string
}

export const BOTTLED_WATER_EVIDENCE: BottledWaterEvidence[] = [
  { brand: 'Nestlé Pure Life', lotMeans: [2277, 49.3, 468], bottleMaximum: 10390, reportedBrandMean: 930 },
  { brand: 'Gerolsteiner', lotMeans: [1410, 204], bottleMaximum: 5106, reportedBrandMean: 807, note: 'The 204/L lot was glass; the 1,410/L lot was plastic.' },
  { brand: 'Aqua', lotMeans: [37.1, 705, 404], bottleMaximum: 4713 },
  { brand: 'Aquafina', lotMeans: [252, 174], bottleMaximum: 1295 },
  { brand: 'Bisleri', lotMeans: [826, 213, 3.72], bottleMaximum: 5230 },
  { brand: 'Dasani', lotMeans: [165, 74.6], bottleMaximum: 335 },
  { brand: 'E-Pura', lotMeans: [686, 20, 37.3], bottleMaximum: 2267 },
  { brand: 'Evian', lotMeans: [197, 58.2], bottleMaximum: 256 },
  { brand: 'Minalba', lotMeans: [40.1, 12.5, 150], bottleMaximum: 863, reportedBrandMean: 63.1 },
  { brand: 'San Pellegrino', lotMeans: [30.3], bottleMaximum: 74, reportedBrandMean: 30, note: 'Figure 1/Results reports the brand mean rounded to 30.0/L.' },
  { brand: 'Wahaha', lotMeans: [156, 66.7, 67.1], bottleMaximum: 731 },
  { brand: 'Smartwater', lotMeans: [], note: 'Not in the named 2018 cohort; no number assigned here.' },
  { brand: 'Fiji', lotMeans: [], note: 'Not in the named 2018 cohort; no number assigned here.' },
  { brand: 'Voss', lotMeans: [], note: 'Not in the named 2018 cohort; no number assigned here.' },
  { brand: 'Mountain Valley', lotMeans: [], note: 'Not in the named 2018 cohort; no number assigned here.' },
]

export function lotMeansLabel(row: BottledWaterEvidence): string {
  return row.lotMeans.length ? row.lotMeans.map(n => n.toLocaleString('en-US')).join(' / ') : 'Not measured in this cohort'
}
